import React, { useState, useEffect } from 'react';
import { LocalPersistence } from '../../../factories';
import { Tabs, Card, Button, message, Form, Modal } from 'antd';
import PageContainer from '../../CSIComponents/PageContainer';
import ReferenceAdd from './ReferenceAdd';
import ReferenceEdit from '../Reference/ReferenceEdit';
import ReferenceDetail from '../Reference/ReferenceDetail';
import TransportationAdd from './TransportationAdd';
import TransportationEdit from '../Transportation/TransportationEdit'
import TransportationDetail from '../Transportation/TransportationDetail'
import Loading from './../../Loading';
import { deleteRefPoint } from '@services/referencepoint'
import { sessionType } from '@interfaces/index'
import { ApiCallsFactory } from "@factories/index"
import styles from './../index.module.css'
import ActionButtonsBar from '../../ui/ActionButtonsBar'
const { TabPane } = Tabs;
interface propsTypes {
    isEditable: void | any,
    cancelEditable: void | any,
    setdetailFlag: void | any,
    setAddFlag: void | any,
    rowData: void | any,
    mockData: void | any,
    test?: void | any,
    getData: void | any,
    testDetailFlag: void | any
}
const TabInfo = (props: propsTypes | any) => {
    const [editFlag, setEditFlag] = useState(props.isOnEdit)
    const [rowData, setRowData] = useState(props.rowData)
    const generalObj = props.rowData && JSON.parse(JSON.stringify(props.rowData))
    const add = props.add
    const [isdetail, setIsdetail] = useState(props.isdetail)
    const [activeTab, setActiveTab] = useState('1')
    const [loadingFlag, setLoadingFlag] = useState(false);
    const [form] = Form.useForm();
    const [disabledStatus, setDisabledStatus] = useState(true)
    const changeTab = (key: string) => {
        setActiveTab(key)
    }
    const saveGeneralData = async () => {
        form.validateFields().then(async (formData) => {
            setLoadingFlag(true)
            for (let i = 0; i < formData.transportation.length; i++) {
                if (formData.transportation[i] == undefined) {
                    formData.transportation.splice(i, 1)
                    i--
                }
            }
            formData.transportation.forEach((item: any) => {
                item.type = item.type || '';
                item.typedetail = item.typedetail || '';
                item.inclunded = item.inclunded || '';
                item.description = item.description || '';
                item.charge = item.charge || '';
                item.currency = item.currency || '';
                item.chargeunit = item.chargeunit || '';
                if (item.schedule) {
                    item.schedule.forEach((cell: any) => {
                        cell.startdate = cell.startdate || '';
                        cell.enddate = cell.enddate || '';
                        cell.operationtime.forEach((element: any, index: number) => {
                            element.starttime = element.starttime || '';
                            element.endtime = element.endtime || '';
                            if (index == 0) {
                                element.dayoftheweek = 'Mon'
                            }
                            else if (index == 1) {
                                element.dayoftheweek = 'Tue'
                            }
                            else if (index == 2) {
                                element.dayoftheweek = 'Wed'
                            }
                            else if (index == 3) {
                                element.dayoftheweek = 'Thu'
                            }
                            else if (index == 4) {
                                element.dayoftheweek = 'Fri'
                            }
                            else if (index == 5) {
                                element.dayoftheweek = 'Sat'
                            }
                            else if (index == 6) {
                                element.dayoftheweek = 'Sun'
                            }
                        })
                    })
                } else {
                    item.schedule = [{
                        startdate: '',
                        enddate: '',
                        operationtime: [
                            {
                                dayoftheweek: "Mon",
                                starttime: "",
                                endtime: ""
                            },
                            {
                                dayoftheweek: "Tue",
                                starttime: "",
                                endtime: ""
                            },
                            {
                                dayoftheweek: "Wed",
                                starttime: "",
                                endtime: ""
                            },
                            {
                                dayoftheweek: "Thu",
                                starttime: "",
                                endtime: ""
                            },
                            {
                                dayoftheweek: "Fri",
                                starttime: "",
                                endtime: ""
                            },
                            {
                                dayoftheweek: "Sat",
                                starttime: "",
                                endtime: ""
                            },
                            {
                                dayoftheweek: "Sun",
                                starttime: "",
                                endtime: ""
                            },

                        ]
                    }]
                }
            });
            const get_session = new LocalPersistence('session')

            const session: sessionType = await get_session.getSessionPersistence()
            const referencepoint = {
                supplier: session.supplier,
                propertyId: session.propertyId,
                property: {
                    referencepoint: [
                        {
                            refpointid: formData.refpointid,
                            refpointlangid: formData.refpointlangid,
                            id: formData.id,
                            name: formData.name,
                            type: formData.type,
                            typedetail: formData.typedetail,
                            airportcode: formData.airportcode,
                            directiondescription: formData.directiondescription,
                            category: formData.category,
                            direction: formData.direction,
                            distance: formData.distance,
                            distanceunit: formData.distanceunit,
                            toorfrom: formData.toorfrom,
                            isnearest: formData.isnearest,
                            isprimary: formData.isprimary,
                            longitude: formData.longitude,
                            latitude: formData.latitude,
                            rank: formData.rank,
                            state: formData.state,
                            country: formData.country,
                            accuracy: formData.accuracy,
                            hotellocation:formData.hotellocation,
                            transportation: formData.transportation
                        }
                    ]
                }
            }

    



            try {
                const updateRefPoint = new ApiCallsFactory('/property/referencepoint', session.token, referencepoint)
                await updateRefPoint.putData()
                setRowData(formData)
                setLoadingFlag(false)
                props.cancelEditable()
                setIsdetail(true)
                setEditFlag(!editFlag)
                form.resetFields();

                props.getData()
                props.setdetailFlag(false)
            } catch (err: any) {
                message.error({
                    content: err.message || err[0].error[0].message || err[1].error[0].message || err[2].error[0].message
                });
                setLoadingFlag(false)
                props.cancelEditable()
                setIsdetail(true)
                setEditFlag(!editFlag)
            }

   
        }, () => {
            message.error({
                content: 'Check all the fileds please',
            });
        })
    }
    const validateFieldsError = (changedValues: any, allValues: any) => {
        form.validateFields().then(() => {
            setDisabledStatus(false)
        }).catch(() => {
            const detailErrNum = form.getFieldsError()?.filter(({ errors }: { errors: any }) => errors.length).length;
            if (detailErrNum === 0) {
                setDisabledStatus(false)
            } else {
                setDisabledStatus(true)
            }
        })
    }
    const addSubmit = async () => {
        form.validateFields().then(async (formData) => {
            // setLoadingFlag(true)
            for (let i = 0; i < formData.transportation.length; i++) {
                if (formData.transportation[i] == undefined) {
                    formData.transportation.splice(i, 1)
                    i--
                }
            }
            formData.transportation.forEach((item: any) => {
                item.type = item.type || '';
                item.typedetail = item.typedetail || '';
                item.inclunded = item.inclunded || '';
                item.description = item.description || '';
                item.charge = item.charge || '';
                item.currency = item.currency || '';
                item.chargeunit = item.chargeunit || '';
                if (item.schedule) {
                    item.schedule.forEach((cell: any) => {
                        cell.startdate = cell.startdate || '';
                        cell.enddate = cell.enddate || '';
                        cell.operationtime.forEach((element: any, index: number) => {
                            element.starttime = element.starttime || '';
                            element.endtime = element.endtime || '';
                            if (index == 0) {
                                element.dayoftheweek = 'Mon'
                            }
                            else if (index == 1) {
                                element.dayoftheweek = 'Tue'
                            }
                            else if (index == 2) {
                                element.dayoftheweek = 'Wed'
                            }
                            else if (index == 3) {
                                element.dayoftheweek = 'Thu'
                            }
                            else if (index == 4) {
                                element.dayoftheweek = 'Fri'
                            }
                            else if (index == 5) {
                                element.dayoftheweek = 'Sat'
                            }
                            else if (index == 6) {
                                element.dayoftheweek = 'Sun'
                            }
                        })
                    })
                } else {
                    item.schedule = [{
                        startdate: '',
                        enddate: '',
                        operationtime: [
                            {
                                dayoftheweek: "Mon",
                                starttime: "",
                                endtime: ""
                            },
                            {
                                dayoftheweek: "Tue",
                                starttime: "",
                                endtime: ""
                            },
                            {
                                dayoftheweek: "Wed",
                                starttime: "",
                                endtime: ""
                            },
                            {
                                dayoftheweek: "Thu",
                                starttime: "",
                                endtime: ""
                            },
                            {
                                dayoftheweek: "Fri",
                                starttime: "",
                                endtime: ""
                            },
                            {
                                dayoftheweek: "Sat",
                                starttime: "",
                                endtime: ""
                            },
                            {
                                dayoftheweek: "Sun",
                                starttime: "",
                                endtime: ""
                            },

                        ]
                    }]
                }
            });
            const get_session = new LocalPersistence('session')
            const session: sessionType = await get_session.getSessionPersistence()
            const referencepoint = {
                supplier: session.supplier,
                propertyId: session.propertyId,
                property: {
                    referencepoint: [
                        {
                            id: formData.id,
                            name: formData.name,
                            type: formData.type,
                            typedetail: formData.typedetail,
                            airportcode: formData.airportcode,
                            directiondescription: formData.directiondescription,
                            category: formData.category,
                            direction: formData.direction,
                            distance: formData.distance,
                            distanceunit: formData.distanceunit,
                            toorfrom: formData.toorfrom,
                            isnearest: formData.isnearest,
                            isprimary: formData.isprimary,
                            longitude: formData.longitude,
                            latitude: formData.latitude,
                            rank: formData.rank,
                            state: formData.state,
                            country: formData.country,
                            accuracy: formData.accuracy,
                            hotellocation: formData.hotellocation,
                            transportation: formData.transportation
                        }
                    ]
                }
            }
            setLoadingFlag(true)
            try {
                const addRefPoint = new ApiCallsFactory('/property/referencepoint', session.token, referencepoint)
                await addRefPoint.postData();
                setLoadingFlag(false)
                props.test()
                props.getData()
                props.cancelEditable();
            } catch (err: any) {
                message.error({
                    content: err.message || err[0].error[0].message || err[1].error[0].message || err[2].error[0].message
                });
                setLoadingFlag(false)
                props.test()
                props.getData()
                props.cancelEditable();
            }

        }, err => {
            message.error({
                content: 'Check all the fileds please',
            });
        })

    }
    const ModalHead = () => {
        return (
            <div style={{
                position: 'absolute',
                left: 0,
                top: 0,
                height: '50px',
                lineHeight: '50px',
                textIndent: '10px',
                borderBottom: '1px solid #ccc',
                color: '#fff',
                background: '#06789D',
                fontSize: 18,
                width: '100%'
            }}>Confirm</div>
        )
    }
    const hanDelete = async () => {
        const deleteTitle = 'Reference Points'
        const get_session = new LocalPersistence('session')
        let session: sessionType = await get_session.getSessionPersistence()
        Modal.confirm({
            title: <ModalHead />,
            centered: true,
            icon: '',
            content: `Are you sure you want to delete ${deleteTitle} ?`,
            cancelText: 'Cancel',
            okText: 'Delete',
            onOk() {
                setLoadingFlag(true)
                const deleteData = {
                    supplier: session.supplier,
                    propertyId: session.propertyId,
                    property: {
                        referencepoint: [
                            {
                                refpointid: props.rowData.refpointid,
                                refpointlangid: props.rowData.refpointlangid,
                            }
                        ]
                    }
                }
                deleteRefPoint(deleteData).then(res => {
                    setLoadingFlag(false)
                    if (res.result.success) {
                        props.testDetailFlag()
                        props.getData()
                        props.cancelEditable();
                    } else {
                        message.error({
                            content: res?.error[0]?.message || 'operation failed'
                        });
                    }
                }, err => {
                    setLoadingFlag(false)
                    props.testDetailFlag()
                    props.getData()
                    props.cancelEditable();
                    message.error({
                        content: err.message || err.error[0].message
                    });
                })
            }, onCancel() {
                setLoadingFlag(false)
            },
        })

    }
    const edit = () => {
        return <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <div style={{ margin: '0 10px 0 0' }}>
                <Button className="db-edit-btn" onClick={() => { props.cancelEditable(); form.resetFields(); props.setdetailFlag(false) }}>Back</Button>
            </div>
            <div>
                <Button className="db-edit-btn" onClick={() => { setEditFlag(!editFlag); props.isEditable(); setIsdetail(false) }} >
                    Edit
                </Button>
            </div>
        </div>
    }

    const saveAndCancel = (
        <ActionButtonsBar
            onDelete={hanDelete}
            onCancel={() => {
                setEditFlag(!editFlag)
                props.cancelEditable()
                setIsdetail(true)
                form.resetFields()
            }}
            onSave={saveGeneralData}
            disabledSave={disabledStatus}
        />
    )
    const addSave = (
        <ActionButtonsBar
            onCancel={() => {
                props.cancelEditable()
                form.resetFields()
                props.test()
            }}
            onSave={addSubmit}
            disabledSave={disabledStatus}
        />
    )

    return (
        <>
            <PageContainer>
                <Card style={{ marginTop: -45, marginBottom: 60 }}>
                    <div>
                        {!isdetail && props.rowData ?
                            <>
                                <Form
                                    form={form}
                                    layout="vertical"
                                    initialValues={{ ...rowData }}
                                    style={{ paddingLeft: 0 }}
                                    onValuesChange={validateFieldsError}
                                >
                                    <Tabs type="card" defaultActiveKey={activeTab} onChange={changeTab} className={styles.paddingLeft}>
                                        <TabPane tab='Reference Point Name' key="1" forceRender={true}>
                                            {editFlag ? <ReferenceEdit rowData={rowData} /> : ''}
                                        </TabPane>
                                        <TabPane tab='Transportation' key="2" forceRender={true}>
                                            {editFlag ? <TransportationEdit currentForm={form} rowData={rowData} validateFieldsError={validateFieldsError} /> : ''}
                                        </TabPane>
                                    </Tabs>
                                </Form>
                            </>
                            : null
                        }
                        {isdetail ?
                            <>
                                <Tabs type="card" defaultActiveKey={activeTab} className={styles.paddingLeft} onChange={changeTab} tabBarExtraContent={props.isdetail ? edit() : saveAndCancel}>
                                    <TabPane tab='Reference Point Name' key="1" forceRender={true}>
                                        <ReferenceDetail rowData={rowData} />
                                    </TabPane>
                                    <TabPane tab='Transportation' key="2" forceRender={true}>
                                        <TransportationDetail rowData={rowData} />
                                    </TabPane>
                                </Tabs>
                            </>
                            : null
                        }
                        {add &&
                            <>
                                <Form
                                    form={form}
                                    layout="vertical"
                                    name="basic"
                                    onValuesChange={validateFieldsError}
                                >
                                    <Tabs type="card" defaultActiveKey="1" className={styles.paddingLeft} >
                                        <TabPane tab='Reference Point Name' key="1" forceRender={true} style={{ paddingLeft: 16 }}>
                                            {add && <ReferenceAdd />}
                                        </TabPane>
                                        <TabPane tab='Transportation' key="2" forceRender={true} style={{ paddingLeft: 16 }}>
                                            {add && <TransportationAdd currentForm={form} validateFieldsError={validateFieldsError} />}
                                        </TabPane>
                                    </Tabs>
                                </Form>
                            </>
                        }
                    </div>
                </Card>
            </PageContainer>
            {editFlag && saveAndCancel}
            {add && addSave}
            {
                loadingFlag && <div className={styles.loadingWrap}><Loading type="large" /></div>
            }
        </>
    )
}

export default TabInfo;

